// Import routes
import { CONFIGURATOR_PATHS } from 'components/routes/configurator/routes';
import { MAIN_PATHS } from 'components/routes/app_routes/paths';

export const NAV_EXCLUDED_PATHS = [CONFIGURATOR_PATHS.SUMMARY, CONFIGURATOR_PATHS.PAYMENT_METHOD, MAIN_PATHS.PAYMENT_VERIFICATION];
